export const enum LineCap {
  Round = "round",
  Arrow = "arrow",
}
